<template>
	<el-drawer title="采购申请单查看" :visible.sync="visible" @close='comStateClose' size="56%" :close-on-press-escape="false"
		id="comDrawer">
		<div class="drawerView">
			<div class="drawerViewT">
				<div class="drawerRow">
					<div class="drawerCol">申请单号:{{detailData.orderNo}}</div>
					<div class="drawerCol" v-if="detailData.applier">申请人:{{detailData.applier.userName}}</div>
					<div class="drawerCol">申请日期:{{detailData.applyTime}}</div>
				</div>
				<div class="drawerRow">
					<div class="drawerCol" v-if="detailData.orderStatus">采购状态:{{detailData.orderStatus.name}}</div>
					<div class="drawerCol">采购数量:{{detailData.totalCount}}</div>
					<div class="drawerCol">采购备注:{{detailData.remark}}</div>
				</div>
				<div class="drawerRow">
					<div class="drawerCol">审批时间:{{detailData.applyOrderApproveTime}}</div>
					<div class="drawerCol">审批人:{{detailData.applyOrderApproveUser}}</div>
					<div class="drawerCol">审批说明:{{detailData.applyOrderApproveRemark}}</div>
				</div>
				<el-table :data="detailData.orderItems" style="width: 100%">
					<el-table-column prop="materialName" label="名称">
					</el-table-column>
					<el-table-column prop="brand" label="品牌">
					</el-table-column>
					<el-table-column prop="unit" label="单位">
					</el-table-column>
					<el-table-column prop="categoryInfo.name" label="分类">
					</el-table-column>
					<el-table-column prop="applyCount" label="采购数量">
					</el-table-column>
					<el-table-column prop="remark" label="备注">
					</el-table-column>
				</el-table>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	export default {
		props: {
			comState: { //显示状态
				default: false
			},
			navId:{
				default:''
			}
		},
		data() {
			return {
				visible: true,
				detailData:{},
			}
		},
		mounted(){
			console.log('id',this.navId)
			this.getTableData()
		},
		methods: {
			//获取表格数据
			getTableData(){
				let params = {
					orderId:this.navId
				}
				this.$http.get(process.env.VUE_APP_Url_8022 + '/api/PurchaseApply/info',params).then(
					res => {
						if (res.code == 0) {
							console.log('详情',res.data)
							this.detailData = res.data;
						}
					})
			},
			//向父组件发射关闭弹框
			comStateClose() {
				this.$emit("closeOn", false);
			},
		},
		watch: {
			// 监视状态发生改变
			comState() {
				this.visible = this.comState;
			},
		},
	}
</script>

<style scoped lang="scss">
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;

		.drawerViewT {
			height: calc(100% - 60px);
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;

			.drawerRow {
				display: flex;
				justify-content: space-between;
				padding: 0 20px;

				.drawerCol {
					width: 32%;
					line-height: 40px;
					font-size: 14px;
				}
			}
		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: #F58B2F;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: #E3E3E3;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #666;
				cursor: pointer;
			}
		}
	}
</style>
